import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

export type ViewCartStylesParams = {
  viewCartDefaultFont: StyleParamType.Font;
  viewCartDefaultTextColor: StyleParamType.Color;
  viewCartDefaultBackgroundColor: StyleParamType.Color;
  viewCartDefaultBorderWidth: StyleParamType.Number;
  viewCartDefaultBorderColor: StyleParamType.Color;
  viewCartCornerRadiusTopLeft: StyleParamType.Number;
  viewCartCornerRadiusTopRight: StyleParamType.Number;
  viewCartCornerRadiusBottomLeft: StyleParamType.Number;
  viewCartCornerRadiusBottomRight: StyleParamType.Number;
  viewCartCornerRadiusLinked: StyleParamType.Number;

  viewCartHoverFont: StyleParamType.Font;
  viewCartHoverTextColor: StyleParamType.Color;
  viewCartHoverBackgroundColor: StyleParamType.Color;
  viewCartHoverBorderColor: StyleParamType.Color;

  viewCartShowIcon: StyleParamType.Boolean;
  viewCartIconType: StyleParamType.Number;
  viewCartIconSize: StyleParamType.Number;
  viewCartIconColor: StyleParamType.Color;
};

export const viewCartStylesParams = createStylesParams<ViewCartStylesParams>({
  viewCartDefaultFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        htmlTag: 'p',
        size: params.isMobile ? 14 : 16,
      })(params),
  },
  viewCartDefaultTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  viewCartDefaultBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  viewCartDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  viewCartDefaultBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
  },
  viewCartCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  viewCartCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  viewCartCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  viewCartCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  viewCartCornerRadiusLinked: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },

  viewCartHoverFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Body-M', {
        htmlTag: 'p',
        size: params.isMobile ? 14 : 16,
      })(params),
  },
  viewCartHoverTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
  viewCartHoverBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 1),
  },
  viewCartHoverBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
  },

  viewCartShowIcon: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false,
  },
  viewCartIconType: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  viewCartIconSize: {
    type: StyleParamType.Number,
    getDefaultValue: ({ isMobile }) => (isMobile ? 16 : 24),
  },
  viewCartIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
  },
});
